import { TailSpin } from 'react-loader-spinner'

const Loader = () => (
  <div style={styles.container}>
    <TailSpin
      height='50'
      width='50'
      color='#4fa94d'
      ariaLabel='tail-spin-loading'
      radius='1'
      wrapperStyle={styles.wrapperStyle}
      visible={true}
    />
  </div>
)

export default Loader

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  wrapperStyle: {
    backgroundColor: '#fff',
    padding: 20,
    borderRadius: 10,
  },
}
